import React, { useContext, useEffect, useState } from 'react';
import MobileSearchBar from '../MobileSearchBar';
import DesktopSearchBar from '../DesktopSearchBar';
import SEARCH_WIDGET_UTILS from './utils/utils';
import { searchWidgetContextType } from '../../../reducers/searchWidgetReducer';
import { SingleTrainClass } from '../../route_info/TrainClasses';
import { isMobile } from '../../../utils/commonUtils';

const SEARCH_WIDGET_MAP = {
  MOBILE: 'MOBILE',
  DESKTOP: 'DESKTOP',
  NONE: 'NONE'
};
type SearchWidgetProps = {
  openDatePickerOnMount?: boolean;
  topFix?: boolean;
  modifySearchProps?: boolean;
  pageWiseContext: any;
  templateId?: any;
  searchButtonTitle?: string;
  onMountInitSearchWidget?: () => void;
  classNode?: SingleTrainClass;
  pageName?: string;
};

export const SearchWidget = ({
  openDatePickerOnMount = false,
  topFix = true,
  modifySearchProps = false,
  pageWiseContext,
  templateId,
  searchButtonTitle,
  onMountInitSearchWidget,
  classNode,
  pageName
}: SearchWidgetProps) => {
  const context = useContext<searchWidgetContextType>(pageWiseContext);
  const {
    searchWidgetState: { isCalendarOpen, fromFilter, toFilter, trainNumber, toCityNameUsed, fromCityNameUsed },
    searchWidgetDispatch
  } = context;
  const { closeCalendar, openCalendar, setFromCity, setToCity } =
    SEARCH_WIDGET_UTILS.SEARCH_COMPONENT_UTILS(searchWidgetDispatch);
  useEffect(() => {
    onMountInitSearchWidget && onMountInitSearchWidget();
    const isMobileDevice = isMobile();
    isMobileDevice ? setComponentToShow(SEARCH_WIDGET_MAP.MOBILE) : setComponentToShow(SEARCH_WIDGET_MAP.DESKTOP);
  }, []);
  const [componentToShow, setComponentToShow] = useState(SEARCH_WIDGET_MAP.NONE);
  return (
    <React.Fragment>
      {componentToShow === SEARCH_WIDGET_MAP.MOBILE && (
        <MobileSearchBar
          fromStationNode={fromFilter}
          toStationNode={toFilter}
          closeCalendar={closeCalendar}
          openCalendar={openCalendar}
          setFromCity={setFromCity}
          setToCity={setToCity}
          isCalendarOpen={isCalendarOpen}
          trainNumber={trainNumber}
          templateId={templateId}
          searchButtonTitle={searchButtonTitle}
          modifySearchProps={modifySearchProps}
          pageName={pageName}
        />
      )}
      {componentToShow === SEARCH_WIDGET_MAP.DESKTOP && (
        <DesktopSearchBar
          fromStationNode={fromFilter}
          toStationNode={toFilter}
          closeCalendar={closeCalendar}
          openCalendar={openCalendar}
          setToCity={setToCity}
          setFromCity={setFromCity}
          isCalendarOpen={isCalendarOpen}
          trainNumber={trainNumber}
          openDatePickerOnMount={openDatePickerOnMount}
          topFix={topFix}
          sourceCityEn={fromCityNameUsed}
          destinationCityEn={toCityNameUsed}
          classNode={classNode}
          pageName={pageName}
        />
      )}
    </React.Fragment>
  );
};

export default SearchWidget;
